import { Component, HostBinding } from '@angular/core';
import { FooterComponent } from '../shared/footer.component';
import { HeaderComponent } from '../shared/header.component';

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.css'],
  standalone: true,
  imports: [FooterComponent, HeaderComponent]
})
export class PolicyComponent {

  @HostBinding('style.width') public readonly WIDTH = '100%';

  title = 'webapp';
  scrollToElement($element: any): void {
    console.log($element);
    $element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
  }

}
